@if (view() === 'desktop') {
  <div class="industries-dropdown-overlay" (click)="toggleIsOpen()"></div>

  <div class="industries-dropdown-content">
    <div class="industries-grid">
      @for (industry of industries; track industry.route) {
        <a [routerLink]="[industry.route]"
           class="industry-card"
           (click)="selectOption()">
          <h3 class="industry-title">{{ industry.title | translate }}</h3>

          <div class="industry-logos">
            @for (logo of industry.logos; track logo.alt) {
              <img [ngSrc]="logo.src"
                   [width]="logo.width"
                   [height]="logo.height"
                   [alt]="logo.alt"
                   class="industry-logo">
            }
          </div>
        </a>
      }
    </div>
  </div>
}

@if (view() === 'mobile') {
  <div class="mobile-solutions">
    <div class="mobile-solutions-trigger" (click)="toggleIsOpen()">
      <span>{{ 'SOLUTIONS.TITLE' | translate }}</span>
      <app-icon class="mobile-solutions-icon" [iconName]="isOpen() ? 'specialArrowUp' : 'specialArrowDown'"></app-icon>
    </div>

    @if (isOpen()) {
      <ul class="mobile-solutions-list" [@smoothCollapse]>
        @for (item of industries; track item.route) {
          <li class="mobile-solutions-item">
            <a class="mobile-solutions-link"
               (click)="selectOption()"
               [routerLink]="[item.route]"
               routerLinkActive="mobile-solutions-link-active"
            >
              {{ item.title | translate }}
            </a>
          </li>
        }
      </ul>
    }
  </div>
}
